module.exports = __webpack_public_path__ + "fonts/segoeui.d9076ed7.ttf";